import { post } from './http';
import TrackingContainer from '../Containers/Tracking.container';

export const add = async ({ articleNumber, quantity = 1 }) => {
  if (!quantity || isNaN(quantity) || parseInt(quantity) <= 0) {
    throw 'Invalid quantity';
  }

  const response = await post('/api/cart/add', {
    articleNumber,
    quantity: parseInt(quantity),
  });
  const resp = await response.json();
  TrackingContainer({
    tracking: 'addToCart',
    data: {
      orderRows: resp.orderRows,
    },
  });
  return resp;
};

export const reorder = async (orderId, rowIndex, quantity) => {
  const response = await post('/api/cart/reorderOneItem', {
    orderId,
    rowIndex,
    quantity,
  });
  return response.json();
};
